import VeneerButton from '@veneer/core/dist/scripts/button'
import styled from 'styled-components'

export const Button = styled(VeneerButton)`
  && {
    white-space: break-spaces;
  }
`
